"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var style_1 = require("@lyearn/style");
function SvgCircleOutline(_props, svgRef) {
    var props = (0, style_1.useSvg)(_props);
    return (React.createElement("svg", tslib_1.__assign({ width: 20, height: 20, viewBox: "0 0 20 20", ref: svgRef }, props),
        React.createElement("circle", { cx: 10, cy: 10, r: 10, fill: "#fff" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 18.6a8.6 8.6 0 100-17.2 8.6 8.6 0 000 17.2zm0 1.4c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10z" })));
}
exports["default"] = React.forwardRef(SvgCircleOutline);
//# sourceMappingURL=CircleOutline.js.map